/*
 * Livera — Intermediária de upgrade de assinatura.
 * Só o comprador de 1 pouch avulso (one-time) vê a oferta.
 * Upgrade = limpar carrinho + add do MESMO pouch como Subscribe & Save -> /checkout.
 */
(function () {
  'use strict';

  // Subscribe & Save, single pouch: same variant, $26.00/mo (selling plan 10319200322).
  var SUB = { id: 43887589195842, qty: 1, plan: 10319200322 };
  var OTP_VARIANT = 43887589195842; // 1-pack one-time ($30)

  function go() { window.location.href = '/checkout'; }

  async function init() {
    var root = document.getElementById('liv-upsell');
    if (!root) return;

    var offer = root.querySelector('[data-offer]');
    var done = root.querySelector('[data-done]');
    var currentEl = root.querySelector('[data-current]');
    var upgradeBtns = root.querySelectorAll('[data-upgrade]');
    var continueBtns = root.querySelectorAll('[data-continue]');

    Array.prototype.forEach.call(continueBtns, function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); go(); });
    });

    var cart = null;
    try {
      cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
    } catch (e) { /* ignore */ }

    if (!cart || !cart.items || !cart.items.length) { go(); return; }

    var item = cart.items[0];
    if (currentEl) {
      var n = item.quantity || 1;
      currentEl.textContent = n + (n > 1 ? ' pouches' : ' pouch');
    }

    // Only the single-pouch one-time buyer sees the offer.
    // Anyone already on a plan, or with more than one pouch, goes straight to checkout.
    var isOTP = item.variant_id === OTP_VARIANT && !item.selling_plan_allocation && item.quantity === 1;
    if (!isOTP) { go(); return; }

    var busy = false;
    function upgrade() {
      if (busy) return;
      busy = true;
      Array.prototype.forEach.call(upgradeBtns, function (b) { b.disabled = true; });

      fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: SUB.id, quantity: SUB.qty, selling_plan: SUB.plan }] })
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          go();
        })
        .catch(function () {
          busy = false;
          Array.prototype.forEach.call(upgradeBtns, function (b) { b.disabled = false; });
        });
    }

    Array.prototype.forEach.call(upgradeBtns, function (b) {
      b.addEventListener('click', upgrade);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
